export const trackCountrySelectOpen = () => ({
    event: 'country selection',
    effect: 'navigate'
});
